import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';

// Import global styles
import './presentation/styles/global/reset.css';
import './presentation/styles/global/variables.css';
import './presentation/styles/global/buttons.css';

// Strict mode ensures better development practices
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);